<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `transaction/placement/${inputs.id}`
            : `transaction/placement`
        "
      >
        <!-- Assigned Date -->
        <div class="form-group row align-items-center">
          <label for="input_assigned_at" class="col-sm-3 mb-0">
            Assigned Date
          </label>
          <app-input
            id="input_assigned_at"
            class="col-sm-9"
            type="date"
            v-model="inputs.assigned_at"
            placeholder="Assigned Date"
						:disabled="true"
            required
          />
        </div>
        
        <!-- Placement Type -->
        <div class="form-group row align-items-center">
          <label for="inputs_placement_type" class="col-sm-3 mb-0">
            Appointment Type
          </label>
          <app-input
            id="inputs_placement_type"
            class="col-sm-9"
            type="search-select"
            :list="placementTypeLists"
            v-model="inputs.placement_type"
						@input="handleAppointmentChange"
            placeholder="Appointment Type"
            required
          />
        </div>
        
				<div
					class="form-group row align-items-center"  v-if="showLocationTest"
				>
					<label for="inputs_location_test" class="col-sm-3 mb-0">
						Location Test
					</label>
					<app-input
						id="inputs_location_test"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.location_test"
						:list="locationTestList"
						placeholder="Location Test"
						:required="true"
						@input="handleLocationChange"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showCenterLocationTest">
					<label for="inputs_center" class="col-sm-3 mb-0">
						Center
					</label>
					
					<app-input
						id="inputs_center"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_center"
						@input="setCenterValue"
            :fetch-url="`/master/center?category=${inputs.location_test}&per_page=50`"
						:placeholder="'Center'"
						list-value-field="name"
					/>
				</div>

				<div class="form-group row align-items-center" v-if="showProduct">
					<label for="input_teaching_type" class="col-sm-3 mb-0">
						Teaching Type
					</label>
					<app-input
						id="input_teaching_type"
						class="col-sm-9"
						type="advance-search-select"
						v-model="input_teaching_type"
						:loaded-per-time="10"
						@input="setTeachingType"
						fetch-url="master/teaching-type"
						placeholder="Teaching Type"
						list-value-field="teaching_type_label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showProduct">
					<label for="input_category_product" class="col-sm-3 mb-0">
						Product Category
					</label>
					<app-input
						id="input_category_product"
						v-model="input_product_category"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						@input="setCategoryProduct"
						fetch-url="master/product-category"
						placeholder="Category Product"
						list-value-field="label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showProduct">
					<label for="input_type_class" class="col-sm-3 mb-0">
						Class Type
					</label>
					<app-input
						id="input_type_class"
						class="col-sm-9"
						type="advance-search-select"
						v-model="input_class_type"
						:loaded-per-time="10"
						@input="setClassType"
						fetch-url="master/course-type"
						placeholder="Class Type"
						list-value-field="course_type_label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showProduct">
					<label for="input_product_level" class="col-sm-3 mb-0">
						Product Level
					</label>
					<app-input
						id="input_product_level"
						class="col-sm-9"
						type="advance-search-select"
						v-model="input_product_level"
						:loaded-per-time="10"
						@input="setProductLevel"
						fetch-url="master/product-level"
						placeholder="Product Level"
						list-value-field="product_level_label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showProduct">
					<label for="input_product_status" class="col-sm-3 mb-0">
						Product Status
					</label>
					<app-input
						id="input_product_status"
						class="col-sm-9"
						type="advance-search-select"
						v-model="input_product_status"
						:loaded-per-time="10"
						@input="setProductStatus"
						fetch-url="master/product-status"
						placeholder="Product Status"
						list-value-field="product_status_label"
						required
					/>
				</div>
				<div class="form-group row align-items-center" v-if="showProduct">
					<label for="input_payment_status" class="col-sm-3 mb-0">
						Payment Status
					</label>
					<app-input
						id="input_payment_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_payment_status"
						@input="setPaymentStatus"
						fetch-url="master/payment-status"
						placeholder="Payment Status"
	          list-value-field="payment_status_label"
						required
					/>
				</div>
        <div class="form-group row align-items-center"  v-if="showProduct">
          <label for="inputs_product_id" class="col-sm-3 mb-0">
            Product Name
          </label>
					<app-input
						id="inputs_product_id"
						class="col-sm-9"
						type="text"
						v-model="input_product_name"
						placeholder="Product Name"
						disabled
					/>
        </div>
        
        
				<div class="form-group row align-items-center" v-if="showPackageName">
					<label for="inputs_packages_name" class="col-sm-3 mb-0">
						Packages Name
					</label>
					<app-input
						id="inputs_packages_name"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_packages_name"
						@input="setPackagesNameValue"
						:fetch-url="inputs.product_id ? `master/list-packages/default-semester?product_id=${inputs.product_id}` : ''"
						placeholder="Packages Name"
						list-value-field="package_name"
						:disabled="!inputs.product_id"
						required
					/>
				</div>

        <!-- Assigned By -->
        <!-- <div class="form-group row align-items-center">
					<label for="inputs_assigned_by" class="col-sm-3 mb-0">
						Assigned By
					</label>
					<app-input
						id="inputs_assigned_by"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.assigned_by"
						placeholder="Assigned By"
						:list="assignedByLists"
						required
					/>
				</div> -->
        <!-- Booked Date -->
        <div class="form-group row align-items-center" v-if="showBookingDate">
          <label for="inputs_booked_date" class="col-sm-3 mb-0">
            Booked Date
          </label>
          <app-input
            id="inputs_booked_date"
            class="col-sm-9"
            type="date"
            v-model="inputs.booked_date"
            placeholder="Booked Date"
            required
          />
        </div>
        <!-- Booked Time -->
        <div class="form-group row align-items-center" v-if="showBookingTime">
          <div class="col-sm-3 mb-0">
            <label for="inputs_booked_time" >
              Booked Time
            </label>
          </div>
          <div class="col-sm-9">
            <input
              id="inputs_booked_time"
              class="form-control"
              type="time"
              :is-enable-minute="false"
              v-model="inputs.booked_time"
              placeholder="Booked Time"
            />
          </div>
        </div>
        
        <div class="form-group row align-items-center"  v-if="showExaminer">
          <label for="inputs_assign_id" class="col-sm-3 mb-0">
            Assigned to <br>examiner
          </label>
          <app-input
            id="inputs_assign_id"
            class="col-sm-9"
            type="advance-search-select"
            :loaded-per-time="10"
            v-model="input_assign_id"
            @input="setAssignId"
						fetch-url="/user-list?role_name=Teacher"
            placeholder="Assigned to examine"
            list-value-field="full_name"
            required
          />
        </div>
        <!-- Completed By -->
        <!-- <div
          class="form-group row align-items-center"
          v-if="modalTitle == this.$t('edit')"
        >
          <label for="inputs_completed_by" class="col-sm-3 mb-0">
            Completed By
          </label>
          <app-input
            id="inputs_completed_by"
            class="col-sm-9"
            type="advance-search-select"
            :loaded-per-time="10"
            v-model="input_completed_by"
            placeholder="Completed By"
            fetch-url="/user-list"
            @input="setCompletedByValue"
            list-value-field="full_name"
            :required="true"
          />
        </div> -->
        <!-- Completed Date -->
        <!-- <div
          class="form-group row align-items-center"
          v-if="modalTitle == this.$t('edit')"
        >
          <label for="inputs_completed_date" class="col-sm-3 mb-0">
            Completed Date
          </label>
          <app-input
            id="inputs_completed_date"
            class="col-sm-9"
            type="date"
            v-model="inputs.completed_date"
            placeholder="Completed Date"
            :required="true"
          />
        </div> -->
        <!-- Completed Time -->
        <!-- <div
          class="form-group row align-items-center"
          v-if="modalTitle == this.$t('edit')"
        >
          <label for="inputs_completed_time" class="col-sm-3 mb-0">
            Completed Time
          </label>
          <app-input
            id="inputs_completed_time"
            class="col-sm-9"
            type="time"
            v-model="inputs.completed_time"
            placeholder="Completed Time"
            :required="true"
          />
        </div> -->
        <!-- Sub Status -->
        <!-- <div class="form-group row align-items-center" v-if="showSubStatus">
          <label for="inputs_sub_status" class="col-sm-3 mb-0">
            Sub Status
          </label>
          <app-input
            id="inputs_sub_status"
            class="col-sm-9"
            type="advance-search-select"
            :loaded-per-time="10"
            v-model="input_sub_status"
            @input="setSubStatusValue"
            :fetch-url="`/master/lead-status?lead_status_id=1&per_page=50`"
            placeholder="Sub Status"
            list-value-field="status"
          />
        </div> -->
        <!-- Reference Type -->
        <!-- <div class="form-group row align-items-center">
					<label for="inputs_reference_type" class="col-sm-3 mb-0">
						Reference Type
					</label>
					<app-input
						id="inputs_reference_type"
						class="col-sm-9"
						type="text"
						v-model="inputs.reference_type"
						placeholder="Reference Type"
						required
					/>
				</div> -->
        
        <div class="form-group row align-items-center" v-if="showDueDate">
          <label for="inputs_due_date" class="col-sm-3 mb-0">
            Due Date
          </label>
          <app-input
            id="inputs_due_date"
            class="col-sm-9"
            type="date"
            v-model="inputs.due_date"
            placeholder="Due Date"
            required
          />
        </div>
        <!-- Notes -->
        
        <div class="form-group row align-items-center">
          <label for="inputs_notes" class="col-sm-3 mb-0"> Notes </label>
          <app-input
            id="inputs_notes"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.notes"
            :placeholder="'Notes'"
          />
        </div>
        <!-- Class -->
        <!-- <div class="form-group row align-items-center">
					<label for="inputs_class_id" class="col-sm-3 mb-0">
						Class
					</label>
					<app-input
						id="inputs_class_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.class_id"
						placeholder="Class"
						:list="classLists"
						required
					/>
				</div> -->
      </form>
    </template>
  </modal>
</template>

<script>
import { PlacementBookingFormMixin } from "./PlacementBookingFormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";
import { UserMixin } from "../../../../../Auth/Mixins/UserMixin";

export default {
  name: "PlacementBookingTableForm",
  mixins: [PlacementBookingFormMixin, ModalMixin, UserMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      preloader: false,
      showExaminer:true,
			input_invoice_type:'',
			input_product_name:'',
			input_teaching_type:'',
			input_product_category:'',
			input_class_type:'',
			input_product_level:'',
			input_product_status:'',
			input_payment_status:'',
			dummy:{
				teaching_type_id : null,
				product_category_id : null,
				class_type_id : null,
				product_level_id : null,
				product_status_id : null,
				payment_status_id : null,
			},
      inputs: {
        product_id:null,
        clc_id_number: this.value.clc_id_number,
        assigned_at: new Date().toISOString().substr(0, 10)
        // sub_status: this.value?.sub_status?.id || 0,
      },
      input_assign_id : {},
    	input_packages_name: {},  
      input_product_id: {},
      input_sub_status: {},
      input_completed_by: {},
			showCenterLocationTest: false,
			showLocationTest : false,
			hideReason: true,
			showProduct : false,
			showPackageName : false,
			showBookingDate: true,
			showBookingTime: true,
			showStatus: false,
			showReason: true,
			showAssignTo: true,
			showSubStatus : true,
			showReason : true,
      showDueDate:false,
      phone: "",
      modalId: this.formId,
      modalTitle: this.$t("add"),
      assignedByLists: [],
      classLists: [],
			input_center :{},
			locationTestList : [
				{ id: "Onsite", value: "Onsite" },
				{ id: "Online", value: "Online" }
			],
      placementTypeLists: [
        { id: 1, value: "Class Trial" },
        { id: 2, value: "Placement Test" },
        { id: 3, value: "Direct" },
      ],
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = 'Reschedule';
      this.preloader = true;
    } else {
      this.inputs.completed_by = this.user.loggedInUser.id;
    }
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        if (this.selectedUrl) {
          this.modalTitle = 'Reschedule';
          this.preloader = true;
        }

        let [subStatusResponse, userResponse, classResponse] =
          await Promise.all([
            axios.get("/master/lead-status?lead_status_id=1&per_page=100"),
            axios.get("/user-list"),
            axios.get("/transaction/course"),
          ]);

        userResponse.data.data.forEach((item) => {
          this.assignedByLists.push({
            id: item.id,
            value: item.full_name
              ? item.full_name
              : item.first_name + " " + item.last_name,
          });
        });

        classResponse.data.data.forEach((item) => {
          this.classLists.push({
            id: item.id,
            value: item.course_name,
          });
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    
		handleLocationChange(value) {
			if(value == 'Onsite'){
				this.showCenterLocationTest = true;
			}else{
				this.showCenterLocationTest = false;
			}
		},
		handleAppointmentChange(value) {
    
			if(value != 3){
          this.showDueDate = false;

          this.showProduct = false;
          this.showPackageName = false;
            
          if(value != 1){
            this.showLocationTest = true;
            if(this.inputs.location_test == 'Onsite'){
              this.showCenterLocationTest = true;
            }
          }else{
            this.showLocationTest = false;
            this.showCenterLocationTest = false;
            this.showProduct = true;
            this.showPackageName = true;
          }
          
          this.showBookingDate = true;
          this.showBookingTime = true;
          this.showStatus = false;
          this.showReason = true;
          this.showAssignTo = true;
          this.showSubStatus = true;
          this.showExaminer = true;

      }else if(value == 3){
          this.showDueDate = true;
          this.showProduct = true;
          this.showPackageName = true;
          this.showCenterLocationTest = false;
          this.showLocationTest = false;
          this.showBookingDate = false;
          this.showBookingTime = false;
          this.showStatus = false;
          this.showReason = false;
          this.showAssignTo = false;
          this.showSubStatus = false;
          this.showExaminer = false;
          if(this.inputs.product_id){
            // this.dataDummy = true;
          }
				
			}

		},
    
		setAssignId(data) {
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "assignee_id", data.id);
			}
			this.$set(this, "input_assign_id", data);
		},
		setCenterValue(data) {
			this.inputs.center_id = this.inputs.center_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.center_id = data.id;
			}
		},
    submit() {
      if (this.inputs.completed_date == null) {
        this.inputs.completed_date = new Date().toISOString().slice(0, 10);
      }
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
      this.inputs = {};
    },

    afterSuccessFromGetEditData(response) {

      const data = response.data;

      const product = data.product_id;

      // this.inputs = response.data;
      Object.assign(this.inputs, data);

      this.handleAppointmentChange(response.data.placement_type.id);
     
			this.input_center = response.data.center;
      this.inputs.update_placement = 1;
      if(product){
        this.fetchPackagesByProduct(product.id,response.data.package_id);
        this.inputs.product_id = product.id;
        this.input_product_name = response.data.product_id.name;
        this.dummy.teaching_type_id = response.data.product_id.teaching_type.teaching_type_id;
        this.input_teaching_type = response.data.product_id.teaching_type;
        this.dummy.product_category_id = response.data.product_id.product_category.id;
        this.input_product_category = response.data.product_id.product_category;
        this.dummy.class_type_id = response.data.product_id.course_type.id;
        this.input_class_type = {
          id: response.data.product_id.course_type?.id,
          course_type_desc: response.data.product_id.course_type?.course_type_desc,
          course_type_label: response.data.product_id.course_type?.course_type_label,
          };
        this.dummy.product_level_id = response.data.product_id.product_level.product_level_id;
        this.input_product_level = response.data.product_id.product_level;
        this.dummy.product_status_id = response.data.product_id.product_status.product_status_id;
        this.input_product_status = response.data.product_id.product_status;
        this.dummy.payment_status_id = response.data.product_id.payment_status.payment_status_id;
        this.input_payment_status = response.data.product_id.payment_status;
      }
    

      this.inputs.placement_type = response.data.placement_type.id;
  
      this.inputs.booked_time = response.data.booked_time.slice(0, -3);

			this.$set(this.inputs, "assignee_id", response.data.assignee_to.id);

			this.$set(this, "input_assign_id", response.data.assignee_to);

      this.preloader = false;
    },

    setProductIdValue(data) {
     
      if (data && data.hasOwnProperty("id")) {
        this.$set(this.inputs, "product_id", data.id);
      }

			this.inputs.product_id = data?.id || null;

			// reset package kalau product tidak ada
			if (!this.inputs.product_id) {
				this.input_packages_name = {};
				this.inputs.package_id = null;
				return;
			}

			// fetch package list berdasarkan product id
			this.fetchPackagesByProduct(this.inputs.product_id);

      this.$set(this, "input_product_id", data);
    },
		async fetchPackagesByProduct(productId,packageId=null) {
			try {
        if(packageId !=null){

          const res = await axios.get(`/master/list-packages/${packageId}`);
          const packages = res.data || {};
          this.input_packages_name = packages;
          this.inputs.package_id = packages.id;

        }else{

          const res = await axios.get("/master/list-packages", {
            params: { product_id: productId }
          });

          const packages = res.data.data || [];

          if (packages.length === 1) {
            this.input_packages_name = packages[0];
            this.inputs.package_id = packages[0].id;
          } else {
            this.input_packages_name = {};
            this.inputs.package_id = null;
          }
        }
			} catch (err) {
				this.input_packages_name = {};
				this.inputs.package_id = null;
			}
		},
		setPackagesNameValue(data) {
			this.inputs.package_id = data.id;
		},
    setCompletedByValue(data) {
      if (data && data.hasOwnProperty("id")) {
        this.$set(this.inputs, "completed_by", data.id);
      }

      this.$set(this, "input_completed_by", data);
    },

    getCompletedDateTime(data) {
      let currentDate = new Date(); // Get the current date and time in local timezone

      let jakartaTime = new Date(
        currentDate.toLocaleString("en-US", {
          timeZone: "Asia/Jakarta",
        })
      );

      // Extract date and time separately
      let completedDate = jakartaTime.toISOString().slice(0, 10); // Date in YYYY-MM-DD format

      // Get hours and minutes separately
      let hours = ("" + jakartaTime.getHours()).padStart(2, "0"); // Hours in 2-digit format
      let minutes = ("" + jakartaTime.getMinutes()).padStart(2, "0"); // Minutes in 2-digit format

      let completedTime = `${hours}:${minutes}`; // Form the time as HH:MM

      let datetime = {
        date: completedDate,
        time: completedTime,
      };

      if (data?.completed_date) {
        datetime.date = data.completed_date;
      }

      if (data?.completed_time) {
        datetime.time = data.completed_time.slice(0, -3);
      }

      return datetime;
    },

    setCompletedDateTime(data) {
      this.$set(this.inputs, "completed_date", data.date); // Store the date
      this.$set(this.inputs, "completed_time", data.time); // Store the time in 24-hour format
    },
		setTeachingType(data){
			this.dummy.teaching_type_id = data.teaching_type_id;
			this.input_teaching_type = data;
			this.getProduct();
		},
		setCategoryProduct(data){
			this.dummy.product_category_id = data.id;
			this.input_product_category = data;
			this.getProduct();
		},
		setClassType(data){
			this.dummy.class_type_id = data.id;
			this.input_class_type = {
				id: data?.id,
				course_type_desc: data?.course_type_desc,
				course_type_label: data?.course_type_label,
			};
			this.getProduct();
		},
		setProductLevel(data){
			this.dummy.product_level_id = data.product_level_id;
			this.input_product_level = data;
			this.getProduct();
		},
		setProductStatus(data){
			this.dummy.product_status_id = data.product_status_id;
			this.input_product_status = data;
			this.getProduct();
		}, 
		setPaymentStatus(data){
			this.dummy.payment_status_id = data.id;
			this.input_payment_status = data;
			this.getProduct();
		},    
		async getProduct(){
			try {
				if(this.dummy.teaching_type_id != null && this.dummy.product_category_id != null && this.dummy.class_type_id != null
					&& this.dummy.product_level_id != null && this.dummy.product_status_id != null && this.dummy.payment_status_id != null
				){
					const getProduct = await axios.get("/master/product/by-criteria", {
						params: { 	teaching_type_id: this.dummy.teaching_type_id,
									product_category_id : this.dummy.product_category_id,
									class_type_id : this.dummy.class_type_id,
									product_level_id : this.dummy.product_level_id,
									product_status_id : this.dummy.product_status_id,
									payment_status_id : this.dummy.payment_status_id
								}
					});
					const products = getProduct.data || [];
					if(products){

						if (products?.payment_status?.payment_status_code) {
							this.inputs.invoice_type = products.payment_status.payment_status_code;
							this.input_invoice_type = products.payment_status.payment_status_code;
						}
						this.inputs.product_id = products.id;
						this.input_product_name = products.name;
						this.fetchPackagesByProduct(this.inputs.product_id,this.inputs.academic_calendar_id);
					}else{
						this.inputs.product_id = null;
						this.input_product_name = null;
						this.inputs.invoice_type = null;
						this.input_invoice_type = null;
						this.input_packages_name = {};
						this.inputs.package_id = null;

					}

				}


			} catch (err) {
				console.error(err);
			}
		}
	},

    // setSubStatusValue(data) {
    //   if (data && data.hasOwnProperty("id")) {
    //     this.inputs.sub_status = data.id;
    //   }

    //   this.$set(this, "input_sub_status", data);
    // },
};
</script>

<style scoped>
	.input-span{
		background: #eee;height: 46px;border: 1px solid #4b6c9d; border-radius: 6px !important;padding: 12px;
	}
</style>
